import React, { useMemo, useState } from 'react';
import NavigationStepper, {
	NavigationStepperComponentParams,
	NavigationStepperItemType,
} from '../../../../../../Components/Stepper/NavigationStepper';
import ManagerCertificateUploadWizardFileUpload from './ManagerCertificateUploadWizardFileUpload';
import ManagerCertificateUploadWizardPasswordEntry from './ManagerCertificateUploadWizardPasswordEntry';
import { WorkplaceCertificateType } from '../../../../../../graphql/graphql';

interface Props {
	type: WorkplaceCertificateType;
	certificateId?: string;
	onDelete: () => void;
	onFinish: () => void;
}

const ManagerCertificateUploadWizard: React.FC<Props> = ({
	type,
	certificateId: certificateIdProps,
	onDelete,
	onFinish,
}) => {
	const [certificateId, setCertificateId] = useState<string | undefined>(
		certificateIdProps,
	);

	const handleUploadFile = (
		isPasswordLess: boolean,
		newCertificateId: string,
		params: NavigationStepperComponentParams,
	) => {
		if (isPasswordLess) {
			onFinish();
		} else {
			setCertificateId(newCertificateId);
			params.setActiveStepPath('passwordEntry');
		}
	};

	const steps: NavigationStepperItemType[] = useMemo(() => {
		const temp: NavigationStepperItemType[] = [
			{
				key: 'fileUpload',
				name: 'file',
				component: params => (
					<ManagerCertificateUploadWizardFileUpload
						certificateType={type}
						certificateId={certificateId}
						onSuccess={(isPasswordLess, newCertificateId) =>
							handleUploadFile(isPasswordLess, newCertificateId, params)
						}
						onDelete={onDelete}
					/>
				),
			},
		];

		if (certificateId) {
			temp.push({
				key: 'passwordEntry',
				name: 'password',
				component: params => (
					<ManagerCertificateUploadWizardPasswordEntry
						onSuccess={onFinish}
						certificateId={certificateId}
					/>
				),
			});
		}

		return temp;
	}, [certificateId]);

	return (
		<NavigationStepper
			steps={steps}
			initialStepPath='fileUpload'
			showStepNavigation={false}
		/>
	);
};

export default ManagerCertificateUploadWizard;
